//BFSG
import styled from 'styled-components'
import * as t from './types'
import * as React from 'react'
import useArrowNavigation from 'hooks/useSliderArrowNavigation'
import Card from './Card'
import theme from 'theme'
import SliderButton from 'theme/atoms/SliderButton'
import useTranslations from 'hooks/useTranslations'
import withTranslations from './withTranslations'

export function CardSlider(props: t.Props) {
  const {
    lastItemRef,
    firstItemRef,
    productListRef,
    lastItemReached,
    firstItemReached,
    handleSlide
  } = useArrowNavigation(0.8)
  const t = useTranslations<'organisms-CardSlider'>()
  return (
    <Wrapper className="CardSlider" data-cy-ctx="organisms/CardSlider">
      <h2 className="title">{props.title}</h2>
      <div className="slider-container">
        <div className="inner-slider" ref={productListRef}>
          <div ref={firstItemRef} className={'firstLast'}>
            &#160;
          </div>
          <CardWrapper className="CardWrapper">
            {props.items.map((item, i) => (
              <Card
                key={i}
                imgSrc={props.context.optImgs[i]}
                name={item.name}
                link={item.link}
              ></Card>
            ))}
          </CardWrapper>
          {!firstItemReached && (
            <SliderButton
              facing="left"
              title={t.asText(false, 'card_slider_prev_button_title')}
              onClick={() => handleSlide('left')}
              data-cy-state="has-prev-button"
              data-cy-handle="prev-button"
            />
          )}
          {!lastItemReached ? (
            <SliderButton
              facing="right"
              title={t.asText(false, 'card_slider_next_button_title')}
              onClick={() => handleSlide('right')}
              data-cy-state="has-next-button"
              data-cy-handle="next-button"
            />
          ) : null}
          <div ref={lastItemRef} className={'firstLast'}>
            &#160;
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default withTranslations(CardSlider)

const Wrapper = styled.div`
  width: 100%;
  max-width: var(--container-size);
  > .title {
    ${theme.ty('rc-2xl', null, 'rc-3xl')}
    margin-bottom: 0.9375rem;
    @media (min-width: ${theme.ms.MD}px) {
      margin-bottom: 1.125rem;
    }
  }
  > .slider-container {
    position: relative;
    > .inner-slider {
      display: flex;
      width: 100%;
      scrollbar-width: none;
      overflow-x: auto;
      align-items: center;
      > .firstLast {
        width: 0;
        align-self: center;
      }
    }
  }
`
const CardWrapper = styled.div`
  display: flex;
  gap: ${theme.spacing('xs')};
  @media (min-width: ${theme.ms.MD}px) {
    gap: ${theme.spacing('m')};
  }
`
